import apiService from "../common/utils/apiService";
import * as orderActions from "../slices/orderSlice";

const ORDER_URL = `/providerTasks`;

export const mockOrderData = [
  {
    name: "Order 1",
    progress: 25,
    aoi: {
      label: "AOI_1",
      coordinates: [
        [
          82.30088612281196,
          55.1368014629208
        ]
      ]
    },
    type: "Geodata Archive",
    standardOrder: {
      priorityLane: "Normal",
      dataType: "MSI",
      imagerADCSDetails: {
        gsd: {
          min: 0.7,
          max: 0
        },
        nadirAngle: {
          min: 0,
          max: 0
        },
        sunAngle: {
          min: 0,
          max: 0
        }
      },
      cloudFreePercentage: 100,
      coverageWindow: "1Day",
      recurring: true
    },
    startTime: "2024-04-01T08:30:00Z",
    endTime: "2024-04-01T08:30:00Z",
    updatedAt: "2024-05-20T13:06:23.722318+05:30",
  },
  {
    name: "Order 2",
    progress: 40,
    aoi: {
      label: "AOI_2",
      coordinates: [
        [78.94161916990316, 69.02192509168688],
        [149.0301157390067, 36.95672933706389],
        [-32.56280719003621, 64.42000821260737],
        [24.782326366504265, 81.61681736934074],
        [78.94161916990316, 69.02192509168688],
      ],
    },
    type: "Standard Order",
    standardOrder: {
      priorityLane: "Normal",
      dataType: "Spectral",
      imagerADCSDetails: {
        gsd: {
          min: 0,
          max: 0
        },
        nadirAngle: {
          min: 0,
          max: 0
        },
        sunAngle: {
          min: 0,
          max: 0
        }
      },
      cloudFreePercentage: 100,
      coverageWindow: "1Day",
      recurring: false
    },
    startTime: "2024-04-01T08:30:00Z",
    endTime: "2024-04-01T08:30:00Z",
    updatedAt: "2024-05-20T13:06:23.722318+05:30",
  },
  {
    name: "Order 3",
    progress: 76,
    aoi: {
      label: "AOI_3",
      coordinates: [
        [73.84464768628555, 27.246375918832612],
        [83.64688644225748, 22.677044055855404],
        [77.07030452930576, 13.52048557244295],
        [67.73782162425795, 20.228910464196318],
        [73.84464768628555, 27.246375918832612],
      ],
    },
    type: "Geodata Archive",
    standardOrder: {
      priorityLane: "Normal",
      dataType: "Spectral",
      imagerADCSDetails: {
        gsd: {
          min: 0,
          max: 0
        },
        nadirAngle: {
          min: 0,
          max: 0
        },
        sunAngle: {
          min: 0,
          max: 0
        }
      },
      cloudFreePercentage: 100,
      coverageWindow: "1Day",
      recurring: true
    },
    startTime: "2024-04-01T08:30:00Z",
    endTime: "2024-04-01T08:30:00Z",
    updatedAt: "2024-05-20T13:06:23.722318+05:30",
  }
];

// export const getOrders = (id) => async (dispatch) => {
//   dispatch(orderActions.getOrdersRequest());
//   try {
//     let url = ORDER_URL;
//     if (id) {
//       url = `${url}/${id}`;
//     };
//     const response = await apiService.get(url, null, {});
//     id ? dispatch(orderActions.getSingleOrdersSuccess(response)) :
//       // dispatch(orderActions.getOrdersSuccess(mockOrderData));
//       // dispatch(orderActions.getOrdersSuccess(response));
//       dispatch(orderActions.getOrdersSuccess(response));
//   } catch (error) {
//     // dispatch(orderActions.getOrdersSuccess(mockOrderData))
//     dispatch(orderActions.getOrdersFailure());
//     console.error('Error fetching data:', error);
//   }
// }

export const getOrders = (options) => async (dispatch) => {
  const filtersOptions =
    options && options.length > 0
      ? { filters: options }   // send filters
      : { filters: [] }; 
  dispatch(orderActions.getOrdersRequest());
  try {
    let url = `search${ORDER_URL}`;
    const response = await apiService.post(url, filtersOptions, {});
      dispatch(orderActions.getOrdersSuccess(response));
  } catch (error) {
    // dispatch(orderActions.getOrdersSuccess(mockOrderData))
    dispatch(orderActions.getOrdersFailure());
    console.error('Error fetching data:', error);
  }
}

export const getConstellations = (AOI, successCallBack) => async (dispatch) => {
  dispatch(orderActions.getConstellationsRequest());
  try {
    let url = `/providers/analyze`;
    const response = await apiService.post(url, AOI, {});
    // most passes first; among ties, successful providers before failed ones
    const providers = [...(response.providers || [])].sort((a, b) => {
      if (b.totalPasses !== a.totalPasses) return b.totalPasses - a.totalPasses;
      return Number(b.success) - Number(a.success);
    });
    dispatch(orderActions.getConstellationsSuccess(providers));
    if (successCallBack) {
      successCallBack();
    }
  } catch (error) {
    dispatch(orderActions.getConstellationsFailure(error));
    console.error('Error creating order:', error);
  }
}

export const getWeather = (params, { isFallback = false } = {}) => async (dispatch) => {
  dispatch(orderActions.getWeatherRequest());
  try {
    const response = await apiService.get('/weather', params);
    // isFallback marks centre-point data standing in for an AOI too big for the bbox grid
    dispatch(orderActions.getWeatherSuccess(isFallback ? { ...response, isFallback } : response));
  } catch (error) {
    dispatch(orderActions.getWeatherFailure(error));
    console.error('Error fetching weather:', error);
  }
}

export const getWeatherBbox = (params, onFailure) => async (dispatch) => {
  dispatch(orderActions.getWeatherRequest());
  try {
    // bbox mode lives on the same /weather endpoint now - the backend picks
    // point vs bbox based on which query params are present
    const response = await apiService.get('/weather', params);
    // normalize to the same { hourly } shape the point endpoint returns,
    // so the UI doesn't need to know which mode was used
    dispatch(orderActions.getWeatherSuccess({ ...response, hourly: response.average_hourly }));
  } catch (error) {
    dispatch(orderActions.getWeatherFailure(error));
    console.error('Error fetching weather:', error);
    if (onFailure) onFailure();
  }
}

export const createOrders = (orderDetails, successCallBack) => async (dispatch) => {
  dispatch(orderActions.createOrderRequest());
  try {
    let url = ORDER_URL;
    const response = await apiService.post(url, orderDetails, {});
    dispatch(orderActions.createOrderSuccess(response));
    if (successCallBack) {
      successCallBack();
    }
  } catch (error) {
    dispatch(orderActions.createOrderFailure());
    console.error('Error creating order:', error);
  }
}

export const getDraftOrders = (AOI, successCallBack) => async () => {
  const getDraftRequest = {
    aoi: AOI,
    analysis_type: 'bunker_events'
  }
  try {
    let url = `/analysis/privateer`;
    const response = await apiService.post(url, getDraftRequest, {});
    if (successCallBack) {
      successCallBack();
    }
  } catch (error) {
    console.error('Error creating order:', error);
  }
}

export const deleteDraftOrder = (id, successCallBack) => async () => {
  try {
      let url = `${ORDER_URL}/${id}`;
      const response = await apiService.delete(url, id);
      if (successCallBack) {
          successCallBack();
      }
  } catch (error) {
      console.error('Error deleting Report:', error);
  }
}